var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguranca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5938 29.25C52.4531 29.5625 53 30.3438 53 31.125C53 40.8906 46.5938 46.2812 42.6094 47.8438C42.2188 48 41.5938 48.1562 40.8125 47.8438C35.8125 45.8906 30.5 39.875 30.5 31.125C30.5 30.3438 31.0469 29.5625 31.8281 29.25L40.8125 25.7344C41.5938 25.4219 42.2969 25.5781 42.6094 25.7344L51.5938 29.25ZM41.75 44.1719C44.4062 42.8438 48.7031 39.0938 49.1719 32.2969L41.75 29.4062V44.1719ZM20.5 28C14.9531 28 10.5 23.5469 10.5 18C10.5 12.5312 14.9531 8 20.5 8C25.9688 8 30.5 12.5312 30.5 18C30.5 23.5469 25.9688 28 20.5 28ZM28 31.125C28 38.625 31.5156 44.4062 35.7344 47.6875C35.2656 47.9219 34.7188 48 34.25 48H6.75C4.64062 48 3 46.3594 3 44.25V41.0469C3 35.2656 7.6875 30.5 13.4688 30.5H14.7969C16.5156 31.3594 18.4688 31.75 20.5 31.75C22.5312 31.75 24.4062 31.3594 26.125 30.5H27.4531C27.6875 30.5 27.8438 30.5781 28.0781 30.5781C28 30.8125 28 30.9688 28 31.125Z",
    fill: "#F4731D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguranca);
export default __webpack_public_path__ + "static/media/seguranca.8235a71591ee0c7b3cd7dcde46436d1a.svg";
export { ForwardRef as ReactComponent };